module.exports = __webpack_public_path__ + "img/silver_lightning.1ca9de29.svg";